import { Hostable } from '../../services/hostable';

export abstract class BlockStyleComponent<T> extends Hostable<T> {}
